import { css, keyframes } from '@emotion/core';
import { isFirefox } from 'react-device-detect';
import { MediaQueries } from '../../../styles/Grid';
import { colorsPalette } from '../../../styles/colors';
import {
  NAV_MAX_HEIGHT,
  NAV_MAX_HEIGHT_SMALL_VIEWPORT,
} from '../../../utils/constants';
import { ContainersWidth } from '../../../styles/Grid/GridSizes';

export const modalStyle = css({
  backgroundColor: 'red',
});

export const navCssObj = {
  padding: '34px 0',
  maxHeight: '96px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',

  [MediaQueries.md]: {
    padding: '34px 0px',
    maxHeight: '96px',
  },

  [MediaQueries.sm]: {
    padding: '10px 0',
    maxHeight: '72px',
  },
  [MediaQueries.lg]: {
    padding: '34px 0px',
    maxHeight: '96px',
  },
  [MediaQueries.xl]: {
    padding: '34px 0px',
    maxHeight: '96px',
    position: 'relative',
  },
};

export const navSticky = stickyTop => {
  return css({
    // position: 'fixed',
    position: 'sticky',
    width: '100%',
    // top: stickyTop,
    top: 0,
    background: 'transparent',
    transition: 'top 200ms linear',
    '.bg-blur': {
      background: isFirefox ? '#fffffff7' : '#ffffffd9',
      position: 'absolute',
      top: '0',
      right: '0',
      bottom: '0',
      left: '0',
      backdropFilter: 'blur(5px)',
    },
  });
};
export const navCss = css({
  padding: '34px 0',

  [MediaQueries.sm]: {
    paddingTop: '0px',
  },
  maxHeight: '96px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
});

export const navContainerCss = css({
  zIndex: 3,
  backgroundColor: colorsPalette.white,
  '.navCss': {
    ...navCssObj,
  },
});

export const darkMode = {
  backgroundColor: colorsPalette.black,
  color: colorsPalette.white,
  justifyContent: 'flex-end',
  [MediaQueries.lgAndUp]: {
    justifyContent: 'space-between',
  },
};

export const CustContainer = css({
  width: '100%',
  position: 'relative',
  marginRight: 'auto',
  marginLeft: 'auto',
  [MediaQueries.sm]: {
    width: ContainersWidth.sm,
  },
  [MediaQueries.md]: {
    width: ContainersWidth.md,
  },
  [MediaQueries.lg]: {
    width: ContainersWidth.lg,
  },
  [MediaQueries.xl]: {
    width: ContainersWidth.xl,
    maxWidth: 1440,
  },
});

export const containerModalCss = css({
  height: '100%',

  // padding: '0 15%',
  '.scrollsec': {
    height: '100%',
  },
});

export const rightSideCloseBtn = css({
  padding: '20px 0px',
  border: '0px',
  background: 'transparent',
  cursor: 'pointer',
  display: 'flex',
  justifyContent: 'flex-end',
  width: '100%',

  i: {
    marginRight: '15px',
  },
});

export const leftSideCloseBtn = css({
  padding: '20px 0px',
  border: '0px',
  background: 'transparent',
  cursor: 'pointer',

  i: {
    marginRight: '15px',
  },
});

export const modalRowSearchCss = css({
  // height: `calc(100% - ${NAV_MAX_HEIGHT}px)`,
  height: 'calc(100% - 120px)',
  [MediaQueries.mdAndUp]: {
    alignItems: 'center',
  },
  [MediaQueries.sm]: {
    marginTop: '100px',
  },
});

export const rowModalCss = css({
  height: `calc(100% - ${NAV_MAX_HEIGHT_SMALL_VIEWPORT}px)`,
  [MediaQueries.mdAndUp]: {
    height: `calc(100% - ${NAV_MAX_HEIGHT}px)`,
  },
});

export const modalCss = {
  zIndex: 9,
};
